import { createContext } from "react";

export const ContextData = createContext({
  mode: false,
  currentUser: null,
});
